export const palette = {
  dark: '#141516',
  grey: '#797979',
  yellow: '#f7a700',
  beige: '#d4ccbd',
  light: '#dddddd',
  red: '#d0091b',
  green: '#61d767',
  sage: '#c2cec3',

  darkTransparent: 'rgba(20, 21, 22, 0.75)',
  lightTransparent: 'rgba(255, 255, 255, 0.1)',
};
